import { BiDraftPendingCard } from '@euler/app/components/message/widgets/bi-visualization/BiDraftPendingCard';
import { BiPalette } from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiGalleryCard } from '../../functions/biGalleryTypes';
import { DashboardVariantCard } from './DashboardVariantCard';

/** A fixture card on the surface it belongs to. */
export const GalleryCard = memo(
  ({ card, palette }: { card: BiGalleryCard; palette: BiPalette }) =>
    card.surface === 'chat' ? (
      <BiDraftPendingCard state={card.state} title={card.title} />
    ) : (
      <DashboardVariantCard card={card} palette={palette} />
    ),
);
